import Vuex from "vuex";
import axios from "axios";

export default new Vuex.Store({
    state: {
        loading: false,
        formulaId: null,
        pipelineSlug: null,
        formulaEntity: null,
        pricingDetails: null,
    },
    getters: {
        variables: state => {
            if (state.formulaEntity) return state.formulaEntity.formula_variables;

            return null;
        },
        lookupVariables: state => {
            if (state.formulaEntity) {
                return state.formulaEntity.formula_variables
                    .filter(f => f.formula_variable_lookup_values.length > 0 || f.has_lookup_value)
                    .sort((a, b) => a.name.localeCompare(b.name));
            }
            return null;
        },
        verticalName: state => {
            if (!state.formulaEntity) return "";

            switch (state.formulaEntity.product_category_id) {
                case 2:
                    return "Mortgage";
                case 20:
                    return "Home Equity";
                case 24:
                    return "Deposits";
                case 27:
                    return "Real Estate";
                default:
                    console.error(`Unknown productCategoryId: ${productCategoryId}`);
                    return "";
            }
        },
        pipelineLabel: state => {
            return state.pipelineSlug.charAt(0).toUpperCase() + state.pipelineSlug.slice(1);
        },
        pipelineSlug: state => {
            return state.pipelineSlug;
        },
        formula: state => {
            return state.formulaEntity;
        },
    },
    actions: {
        async fetchFormula(context, payload) {
            try {
                context.commit("setLoading", true);
                const {data} = await axios.get(
                    `/api/formula/${payload.pipelineSlug}/${payload.formulaId}`
                );
                context.commit("setFormulaEntity", data);
            } catch (error) {
                context.commit("setFormulaEntity", null);
                await this.fireSimpleErrorAlert(
                    `Unable to find ${context.getters.pipelineLabel} Formula ${payload.formulaId}`
                );
            } finally {
                context.commit("setLoading", false);
            }
        },
        async saveFormula(context, {pipelineSlug, formulaId, formula}) {
            try {
                context.commit("setLoading", true);
                const {data} = await axios.post(`/api/formula/${pipelineSlug}/${formulaId}`, {
                    formula,
                });
                context.commit("setFormulaEntity", data);
            } catch (error) {
                console.log(error);
                throw error;
            } finally {
                context.commit("setLoading", false);
            }
        },
        async createFormulaVariable(context, {pipelineSlug, formulaId, variable}) {
            try {
                context.commit("setLoading", true);
                const {data} = await axios.post(
                    `/api/formula/${pipelineSlug}/${formulaId}/variables`,
                    {
                        variable,
                    }
                );

                context.commit("setFormulaEntity", data);
            } catch (error) {
                if (error.response) {
                    throw new Error("CreateFormulaVariableFailure", {
                        cause: {
                            field: "xhr",
                            message: error.response.data.errors[0],
                        },
                    });
                }
            } finally {
                context.commit("setLoading", false);
            }
        },
        async checkPrice(context, {event, formula, formulaId, pipelineSlug}) {
            context.commit("setPricingDetails", null);
            context.commit("setLoading", true);
            try {
                const {data} = await axios.post("/api/tools/price-check", {
                    event: JSON.parse(event),
                    formula: formula,
                    formulaId: formulaId,
                    isShadow: pipelineSlug === 'shadow'
                });
                if (data === "" || data.error) {
                    throw new Error("FormulaExecutionFailure", {
                        cause: [
                            {
                                field: "xhr",
                                message:
                                    "Formula failed to execute: " + (data.error.message || data.error.Message || ''),
                            },
                        ],
                    });
                }
                context.commit("setPricingDetails", data);
            } catch (error) {
                throw error;
            } finally {
                context.commit("setLoading", false);
            }
        },
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        },
        setFormulaEntity(state, payload) {
            state.formulaEntity = payload;
        },
        setPipelineSlug(state, payload) {
            state.pipelineSlug = payload;
        },
        setFormulaId(state, payload) {
            state.formulaId = payload;
        },
        setPricingDetails(state, payload) {
            state.pricingDetails = payload;
        },
    },
});
